// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_jg-j";
export var fulfillmentFormRail = "_jg-i";
export var headerTitleRow = "_jg-l";
export var orderDetailsWrapper = "_jg-g";
export var orderLinkTrigger = "_jg-2";
export var paymentInformationGrid = "_jg-q";
export var paymentSummaryColumn = "_jg-r";
export var phoneShipmentPickerButton = "_jg-e";
export var phoneShipmentPickerButtonContent = "_jg-f";
export var phoneShipmentPickerButtonWrapper = "_jg-d";
export var phoneShipmentPickerTrigger = "_jg-c";
export var shipmentContainer = "_jg-k";
export var shipmentDetailsMainPane = "_jg-h";
export var shipmentNavigationCard = "_jg-a";
export var shipmentNavigationEdgeTrigger = "_jg-6";
export var shipmentNavigationRail = "_jg-3";
export var shipmentNavigationRailEnter = "_jg-5";
export var shipmentNavigationRailHeader = "_jg-9";
export var shipmentNavigationRailOverlay = "_jg-4";
export var shipmentNavigationScrim = "_jg-7";
export var shipmentSummaryFact = "_jg-n";
export var shipmentSummaryGrid = "_jg-m";
export var shipmentSummaryMetadataRow = "_jg-o";
export var shipmentSummaryTags = "_jg-p";
export var shipmentWorkspace = "_jg-0";
export var shipmentWorkspaceBodyTablet = "_jg-8";
export var shipmentWorkspaceContent = "_jg-b";
export var shipmentWorkspaceHeader = "_jg-1";